export const abbreviations = {
  en: {
    '': '',
    thousand: 'K',
    million: 'M',
    billion: 'B',
    trillion: 'T',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  de: {
    '': '',
    thousand: '\xa0Tsd.',
    million: '\xa0Mio.',
    billion: '\xa0Mrd.',
    trillion: '\xa0Bio.',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  es: {
    '': '',
    thousand: '\xa0mil',
    million: '\xa0M',
    billion: '\xa0mil\xa0M',
    trillion: '\xa0B',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  fr: {
    '': '',
    thousand: '\xa0k',
    million: '\xa0M',
    billion: '\xa0Md',
    trillion: '\xa0Bn',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  pt: {
    '': '',
    thousand: '\xa0mil',
    million: '\xa0mi',
    billion: '\xa0bi',
    trillion: '\xa0tri',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  ru: {
    '': '',
    thousand: '\xa0тыс.',
    million: '\xa0млн.',
    billion: '\xa0млрд.',
    trillion: '\xa0трлн.',
    byte: '\xa0B',
    kilobyte: '\xa0кБ',
    megabyte: '\xa0МБ',
    gigabyte: '\xa0ГБ',
    terabyte: '\xa0ТБ',
    kibibyte: '\xa0киБ',
    mebibyte: '\xa0МиБ',
    gibibyte: '\xa0ГиБ',
    tebibyte: '\xa0ТиБ'
  },
  tr: {
    '': '',
    thousand: '\xa0B',
    million: '\xa0Mn',
    billion: '\xa0Mr',
    trillion: '\xa0Tn',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  cn: {
    '': '',
    thousand: '千',
    million: '百万',
    billion: '十亿',
    trillion: '兆',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  jp: {
    '': '',
    thousand: 'K',
    million: 'M',
    billion: 'B',
    trillion: 'T',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  cz: {
    '': '',
    thousand: '\xa0tis.',
    million: '\xa0mil.',
    billion: '\xa0mld.',
    trillion: '\xa0bil.',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  },
  ko: {
    '': '',
    thousand: 'K',
    million: 'M',
    billion: 'B',
    trillion: 'T',
    byte: '\xa0B',
    kilobyte: '\xa0kB',
    megabyte: '\xa0MB',
    gigabyte: '\xa0GB',
    terabyte: '\xa0TB',
    kibibyte: '\xa0KiB',
    mebibyte: '\xa0MiB',
    gibibyte: '\xa0GiB',
    tebibyte: '\xa0TiB'
  }
};
